//@ts-nocheck
import React, { useEffect, useState, useMemo, memo } from "react";
import TopBar from "./topBar";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import { Autocomplete, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { useStoreActions, useStoreState } from "easy-peasy";
import MDBox from "components/MDBox";
import InnerTable from "lib/Tables/InnerTable";
import { useParams } from "react-router-dom";
import filesColumn from "pages/applications/modules/filesColumn";
import filesColumnWithSignature from "pages/applications/modules/filesColumnwithSignature";
import Switch from "@mui/material/Switch";
import { createTheme } from "@mui/material";
import { ThemeProvider } from "@mui/material";
import { get, post, del } from "requests";
import CustomModal from "components/CustomModal";
import MDInput from "components/MDInput";
import FullPageLoader from "components/Loader/FullPage";
import SignNowSignatureModal from "pages/applications/components/SignNowSignatureModal";
import MDSnackbar from "../../../../components/MDSnackbar";
import { rolePermissionExists } from "utils/CommonUtils";
import { READ } from "requests/constants";

interface FilesProps {
  appId: any;
  isReadOnly: boolean;
}

interface FilterCheckboxProps {
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Files: React.FC<FilesProps> = ({ appId, isReadOnly }) => {
  const filterOptions = useMemo(
    () => [
      { label: "Bank Statements", value: "Bank Statements" },
      { label: "Application", value: "Application" },
      { label: "Driver's License", value: "Driver's License" },
      { label: "Tax Returns", value: "Tax Returns" },
      { label: "Corporate Docs", value: "Corporate Docs" },
      { label: "Contract", value: "Contract" },
      { label: "Miscellaneous", value: "Miscellaneous" },
      { label: "Report", value: "Report" },
    ],
    []
  );

  const [filters, setFilters] = useState<{ [key: string]: boolean }>({
    "Bank Statements": true,
    Application: true,
    "Driver's License": true,
    "Tax Returns": true,
    "Corporate Docs": true,
    Miscellaneous: true,
    Contract: true,
    Report: true,
  });

  const mediaAttachments = useStoreState((state: any) => state.fileUploads.mediaAttachments);
  const fileCategories = useStoreState((state: any) => state.fileUploads.fileCategories);

  const getMediaAttachments = useStoreActions(
    (actions: any) => actions.fileUploads.getMediaAttachments
  );
  const getAllMerchantMediaAttachments = useStoreActions(
    (actions: any) => actions.fileUploads.getAllMerchantMediaAttachments
  );
  const deleteMediaAttachment = useStoreActions(
    (actions: any) => actions.fileUploads.deleteMediaAttachment
  );
  const getAllFileCategories = useStoreActions(
    (actions: any) => actions.fileUploads.getAllFileCategories
  );
  const updateFileDetails = useStoreActions(
    (actions: any) => actions.fileUploads.updateFileDetails
  );
  const loading = useStoreState((state: any) => state.fileUploads.mediaLoading);
  const setLoading = useStoreActions((actions: any) => actions.fileUploads.setMediaLoading);
  const [signNowEnabled, setSignNowEnabled] = useState<boolean>(false);

  const params = useParams();
  const [applicationId, setApplicationId] = useState<any>(params.id);
  const [showPrevDocuments, setShowPrevDocuments] = useState<Boolean>(true);
  const [editSelected, setEditSelected] = useState<any>(null);
  const [showEditDocumentPopup, setShowEditDocumentPopUp] = useState<Boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);
  const [showSignaturePopUp, setShowSignaturePopUp] = useState<boolean>(false);
  const [signatureFileUploadData, setSignatureFileUploadData] = useState<any>(null);
  const [selectedMediaId, setSelectedMediaId] = useState<any>(null);
  const [alert, setAlert] = useState<{
    type: "success" | "error" | "warning" | null;
    message: any;
    timeOut: number;
  } | null>(null);
  const downloadFile = useStoreActions((actions: any) => actions.fileUploads.downloadSingleFile);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#2F929F",
      },
    },
  });

  useEffect(() => {
    if (applicationId) {
      const loadMediaAttachments = async () => {
        await getAllMediaAttachments(applicationId);
      };
      loadMediaAttachments();
      getAllFileCategories();
    }
  }, [applicationId, getMediaAttachments]);

  useEffect(() => {
    get("getTenantFeatures").then((response) => {
      const signNow = response["signNow"];
      setSignNowEnabled(signNow);
    });
  }, []);

  const previousAppAttachments = useMemo(() => {
    const filtered = mediaAttachments.filter((attachment) => {
      const category = attachment.category;
      if (category && filters[category] === false) return false;
      return true;
    });

    return filtered.filter(
      (attachment) => attachment.dealApplicationId != applicationId || !attachment.dealApplicationId
    );
  }, [filters, mediaAttachments]);

  const sameAppAttachments = useMemo(() => {
    const filtered = mediaAttachments.filter((attachment) => {
      const category = attachment.category;
      if (category && filters[category] === false) return false;
      return true;
    });
    return filtered.filter((attachment) => attachment.dealApplicationId == applicationId);
  }, [filters, mediaAttachments]);

  const selectAllRowsCurrentFiles = (isChecked: boolean) => {
    if (isChecked) {
      setSelectedFiles(
        sameAppAttachments?.map((attachment) => attachment?.id).filter((item) => item)
      );
    } else {
      setSelectedFiles([]);
    }
  };

  const selectAllRowsPreviousFiles = (isChecked: boolean) => {
    if (isChecked) {
      setSelectedFiles(
        previousAppAttachments?.map((attachment) => attachment?.id).filter((item) => item)
      );
    } else {
      setSelectedFiles([]);
    }
  };

  const handleEditSelected = (selected: any) => {
    setEditSelected(selected);
    setShowEditDocumentPopUp(true);
  };

  const onFilterChange = (filterValue: string) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterValue]: !prevFilters[filterValue],
    }));
  };

  const toggleShowPrevDocuments = (value: Boolean) => {
    setShowPrevDocuments((prevValue) => !prevValue);
  };

  const FilterCheckbox: React.FC<FilterCheckboxProps> = memo(({ label, checked, onChange }) => (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={onChange} />}
      label={
        <Typography fontSize="0.875rem" variant="h6">
          {label}
        </Typography>
      }
      sx={{ whiteSpace: "nowrap", marginRight: 0, display: "flex", alignItems: "center" }}
    />
  ));

  const CategoriesFilter = useMemo(
    () => (
      <Box display="flex" alignItems="center" gap={2} flexWrap="nowrap" px={2} mt={3} mb={-3}>
        {filterOptions.map((filter) => (
          <FilterCheckbox
            key={filter.value}
            label={filter.label}
            checked={filters[filter.value]}
            onChange={() => onFilterChange(filter.value)}
          />
        ))}
      </Box>
    ),
    [filters]
  );

  const getAllMediaAttachments = async (applicationId: any) => {
    try {
      const response = await get(`getDealApplication/${applicationId}`);
      if (response && response.partyId) {
        getAllMerchantMediaAttachments(response.partyId);
      } else if (applicationId) {
        getMediaAttachments({ dealApplicationId: applicationId });
      }
    } catch (error) {
      console.error("Error fetching application details:", error);
    }
  };

  const handleSelectItem = (selected) => {
    console.log("Selected items:", selected);
    if (selectedFiles.includes(selected)) {
      const updatedSelectedFiles = selectedFiles.filter((item) => item !== selected);
      setSelectedFiles(updatedSelectedFiles);
    } else {
      const updatedSelectedFiles = [...selectedFiles, selected];
      setSelectedFiles(updatedSelectedFiles);
    }
  };

  const handleDeleteMediaAttachment = async (media: any) => {
    const isSignatureAvailable = !!(media && media.signatureStatus);
    if (isSignatureAvailable) {
      await del(`signnow/delete/${media.id}`);
    }
    await deleteMediaAttachment(media);
    getAllMediaAttachments(applicationId);
  };

  const handleSignatureSelected = async (
    chipLabel: any,
    applicationId: any,
    mediaId: any,
    isRecordCreated: any
  ) => {
    setSelectedMediaId(mediaId);
    if (status === "Resend Request") {
      resendSignNowRequest(mediaId, applicationId);
    } else if (isRecordCreated) {
      getAllRoles(mediaId);
    } else if (!isRecordCreated && status === "") {
      uploadSignNowDocument(mediaId, applicationId);
    }
  };

  const hideSignNowBasedOnRole = () => {
    try {
      const hideSignNow = rolePermissionExists(
        window.rolePermission?.permissions,
        READ,
        "MCA_DEAL_APPLICATIONS.HIDE_SIGN_NOW"
      );
      return hideSignNow;
    } catch (error: any) {
      return false;
    }
  };

  const finalSameAppColumns = useMemo(() => {
    const columnsWithSignature = filesColumnWithSignature(
      downloadFile,
      handleDeleteMediaAttachment,
      handleEditSelected,
      handleSignatureSelected
    );
    const hideSignNow = hideSignNowBasedOnRole();

    if (!signNowEnabled || hideSignNow) {
      return columnsWithSignature.filter((column) => column.Header !== "Signature");
    }

    return columnsWithSignature;
  }, [signNowEnabled]);

  const resendSignNowRequest = async (mediaId, applicationId) => {
    try {
      setLoading(true);
      await post("signnow/resend", { mediaId, applicationId });
      await getAllMediaAttachments(applicationId);
    } catch (error) {
      let message = "An error Occured";
      if (error?.response && error?.response?.data && error?.response?.data?.message) {
        message = error?.response?.data?.message;
        throw new Error(error?.response?.data?.message);
      } else {
        message = error?.message;
        console.error(error.message || "Unknown error occurred");
      }
      setAlert({ type: "error", message: message });
    } finally {
      setLoading(false);
    }
  };

  const getAllRoles = async (mediaId) => {
    try {
      setLoading(true);
      const response = await get(`signnow/roles/${mediaId}`);
      setSignatureFileUploadData(response);
      setShowSignaturePopUp(true);
    } catch (error) {
      let message = "An error Occured";
      if (error?.response && error?.response?.data && error?.response?.data?.message) {
        message = error?.response?.data?.message;
        throw new Error(error?.response?.data?.message);
      } else {
        message = error?.message;
        console.error(error?.message || "Unknown error occurred");
      }
      setAlert({ type: "error", message: message });
    } finally {
      setLoading(false);
    }
  };

  const uploadSignNowDocument = async (mediaId, applicationId) => {
    try {
      setLoading(true);
      const response = await post("signnow/uploadDocument", { mediaId, applicationId });

      if (!response) {
        getAllMediaAttachments(applicationId);
      }

      if (response && response.errorType && response.errorType === "Bad Request") {
        const message = response.message;
        setAlert({
          type: "error",
          message: message,
        });
        throw new Error(message);
      }
      if (response) {
        setSignatureFileUploadData(response);
        setShowSignaturePopUp(true);
      }
    } catch (error) {
      await getAllMediaAttachments(applicationId);
    } finally {
      setLoading(false);
    }
  };

  const handleEditChange = (field: string, value: string) => {
    setEditSelected((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const renderCurrentDocumentsView = (
    <InnerTable
      table={{
        columns: finalSameAppColumns,
        rows: sameAppAttachments,
      }}
      entriesPerPage={false}
      paginationEnabled={false}
      canSearch={false}
      selectedItem={selectedFiles}
      onSelectItem={handleSelectItem}
      getRowId={(row) => row.id}
      selectAllRows={selectAllRowsCurrentFiles}
    />
  );

  const renderPreviousDocumentsView = (
    <InnerTable
      table={{
        columns: filesColumn(downloadFile, handleDeleteMediaAttachment, handleEditSelected),
        rows: previousAppAttachments,
      }}
      entriesPerPage={false}
      paginationEnabled={false}
      canSearch={false}
      selectedItem={selectedFiles}
      onSelectItem={handleSelectItem}
      getRowId={(row) => row.id}
      selectAllRows={selectAllRowsPreviousFiles}
    />
  );

  const previousDocumentSwitch = (
    <FormControlLabel
      style={{ marginTop: 20, marginBottom: -10, paddingLeft: 20 }}
      control={
        <ThemeProvider theme={theme}>
          <Switch checked={showPrevDocuments} onChange={toggleShowPrevDocuments} />
        </ThemeProvider>
      }
      label="Previous Documents"
    />
  );

  const editDocument = async () => {
    await updateFileDetails(editSelected);
    await getAllMediaAttachments(applicationId);
    setShowEditDocumentPopUp(false);
  };

  return (
    <div style={isReadOnly ? { pointerEvents: "none", opacity: 0.7 } : {}}>
      <Card sx={{ paddingLeft: "2rem", paddingTop: "2rem" }}>
        <MDTypography variant="h4" mb={1}>
          Files
        </MDTypography>
        <TopBar
          appId={applicationId}
          refreshDocs={getAllMediaAttachments}
          selectedFiles={mediaAttachments.filter((attachment) =>
            selectedFiles.includes(attachment.id)
          )}
          categories={fileCategories}
          setSelectedFiles={setSelectedFiles}
        />
        {CategoriesFilter}
        {renderCurrentDocumentsView}
        <MDBox paddingBottom={3}>{previousDocumentSwitch}</MDBox>
        {showPrevDocuments && renderPreviousDocumentsView}
      </Card>

      <CustomModal
        open={showEditDocumentPopup}
        onClose={() => {
          setShowEditDocumentPopUp(false);
          setEditSelected(null);
        }}
        title="Edit Document"
        cancelText="Cancel"
        submitText="Submit"
        onCancel={() => {
          setShowEditDocumentPopUp(false);
        }}
        onSubmit={editDocument}
        maxWidth="sm"
        fullWidth={true}
      >
        <MDBox display="flex" flexDirection="column" width="100%" gap={"20px"}>
          <MDInput
            label="File Name"
            value={editSelected?.name}
            onChange={(e) => handleEditChange("name", e.target.value)}
            disabled
          />
          <Autocomplete
            value={editSelected?.category}
            onChange={(event, newValue) => {
              handleEditChange("category", newValue);
            }}
            options={fileCategories}
            renderInput={(params) => <MDInput {...params} label="Select Category" />}
          />
          <MDInput
            label="Description"
            value={editSelected?.description}
            onChange={(e) => handleEditChange("description", e.target.value)}
          />
        </MDBox>
      </CustomModal>

      <SignNowSignatureModal
        showModal={showSignaturePopUp}
        onClose={() => setShowSignaturePopUp(false)}
        dealApplicationId={applicationId}
        refreshDocs={getAllMediaAttachments}
        signatureData={signatureFileUploadData}
        mediaId={selectedMediaId}
        setLoading={setLoading}
      />

      {alert && (
        <MDSnackbar
          color={alert?.type === "success" ? "success" : "error"}
          icon="notifications"
          title={alert?.type === "success" ? "Success" : "Error"}
          content={alert?.message}
          dateTime=""
          autoHideDuration={alert?.timeOut || 5000}
          open={alert !== null}
          close={() => setAlert(null)}
        />
      )}

      {loading && <FullPageLoader />}
    </div>
  );
};

export default Files;
